import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";
import Loading from "../../shared/loading";
import ResponsiveUtilities from "../../shared/utilities/responsive_utilities";
import SessionController from '../../shared/session';

let loading, unit, enrolmentId, exitCallback, certLink, src;

function loadCertificate() {
    loading = true;
    Requester.post(Gateway.public + "units/certificate/" + unit.enrolment.id + "?enrolmentId=" + enrolmentId)
        .then(function () {
            certLink = Gateway.public + "units/certificate/" + unit.enrolment.id + "?enrolmentId=" + enrolmentId;
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .then(function () {
            load(certLink);
            loading = false;
        });
}

function getHeaderName() {
    if (!unit) {
        return null;
    }

    return SessionController.session.identity.name + ": " + unit.name;
}

function load(url) {
    Requester.getFile(url)
        .then(function (result) {
            let blob = new Blob([result], { type: 'application/pdf' });
            src = URL.createObjectURL(blob);
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
    });
}

const Component_Certificate_Viewer = {
    oninit: function (vnode) {
        enrolmentId = vnode.attrs.enrolmentId;
        unit = vnode.attrs.unit;
        loadCertificate();
        exitCallback = vnode.attrs.callback;
    },
    view: function () {
        return [
            m("#player-bg"),
            m("#player", [
                m(".flex-row justify-between align-center padding", [
                    m("h3.ellipsis", getHeaderName()),
                    m("button.btn-cta", { onclick: exitCallback }, i18n.t("close"))
                ]),
                !loading ? [
                    unit ? [
                        ResponsiveUtilities.mobileAndTabletCheck() && src
                        ? m("div", { class: "centre-content" }, [
                            m("p", i18n.t("doesnt_support_previewing_pdfs")),
                            m("p", {}, [m("a", { class: "hyperlink", target: "_blank", href:src }, i18n.t("download_instead"))])
                        ])
                        : m("object", { data: src, class: "embed-test-responsive", type: "application/pdf", width: "100%", height: "100%" })
                    ] : i18n.t("cant_load")
                ] : m(Loading)
            ])
        ];
    }
};

export default Component_Certificate_Viewer;
